// extracted by mini-css-extract-plugin
module.exports = {"iconHolder":"BookingAttendees_iconHolder__3mH_C","attendeeHolder":"BookingAttendees_attendeeHolder__2i3QH"};